import { render } from "./DaysHighlight.vue?vue&type=template&id=61bd1087"
import script from "./DaysHighlight.vue?vue&type=script&lang=js"
export * from "./DaysHighlight.vue?vue&type=script&lang=js"

import exportComponent from "/Users/guangdong.chen/development/ATech/frontend/app/gantt-elastic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__